// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__gt++s","cards__item":"Cards_cards__item__pw9MU"};